import { Flex } from 'antd';
import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import './App.css';
import MainLayout from './pages/mainLayout/mainLayout.page';



function App() {

  return (
    <RecoilRoot>
      <BrowserRouter basename='/pecheapp'>
        <Flex gap="middle" wrap>
          <MainLayout />
        </Flex>
      </BrowserRouter>
    </RecoilRoot >
  );
}

export default App;
